import { createAction } from "@reduxjs/toolkit";

import {
  FETCH,
  DONE,
  FAIL,
  GET,
  PRINT,
  MODULE,
  EDIT,
  RESET,
  DATA,
  SET,
  STUDY,
  MEDICAL,
  GROUPS,
  REMARK,
  DELETE,
  TOTAL_UVR,
  DISCIPLINES,
  JOURNAL,
  PARAMS, SUBJECTS, LIST, FILTER,
  APPEALS,
  ALL,
  STUDENT,
  BY,
  POST,
  ONE,
  RESULT,
  TEACHERS
} from "../../constants";

export const printStoreReset = createAction<undefined>(PRINT + DATA + RESET);


export const getPrintModule = createAction<undefined>(GET + PRINT + MODULE + FETCH);
export const getPrintModuleDone = createAction<any>(GET + PRINT + MODULE + FETCH + DONE);
export const getPrintModuleFail = createAction<undefined>(GET + PRINT + MODULE + FETCH + FAIL);

export const printSetEdit = createAction<any>(PRINT + MODULE + SET + EDIT + FETCH);
export const printCancelEdit = createAction<any>(PRINT + MODULE + RESET + EDIT + FETCH);

export const printModuleEdit = createAction<any>(PRINT + MODULE + EDIT + FETCH);
export const printModuleEditDone = createAction<any>(PRINT + MODULE + EDIT + FETCH + DONE);
export const printModuleEditFail = createAction<undefined>(PRINT + MODULE + EDIT + FETCH + FAIL);

export const getPrintStudy = createAction<undefined>(GET + PRINT + STUDY + FETCH);
export const getPrintStudyDone = createAction<any>(GET + PRINT + STUDY + FETCH + DONE);
export const getPrintStudyFail = createAction<undefined>(GET + PRINT + STUDY + FETCH + FAIL);

export const editPrintStudy = createAction<any>(EDIT + PRINT + STUDY + FETCH);
export const editPrintStudyDone = createAction<any>(EDIT + PRINT + STUDY + FETCH + DONE);
export const editPrintStudyFail = createAction<undefined>(EDIT + PRINT + STUDY + FETCH + FAIL);

export const getPrintMedical = createAction<undefined>(GET + PRINT + MEDICAL + FETCH);
export const getPrintMedicalDone = createAction<any>(GET + PRINT + MEDICAL + FETCH + DONE);
export const getPrintMedicalFail = createAction<undefined>(GET + PRINT + MEDICAL + FETCH + FAIL);

export const getPrintMedicalGroup = createAction<undefined>(GET + PRINT + MEDICAL + GROUPS + FETCH);
export const getPrintMedicalGroupDone = createAction<any>(GET + PRINT + MEDICAL + GROUPS + FETCH + DONE);
export const getPrintMedicalGroupFail = createAction<undefined>(GET + PRINT + MEDICAL + GROUPS + FETCH + FAIL);

export const printMedicalEdit = createAction<any>(PRINT + MEDICAL + EDIT + FETCH);
export const printMedicalEditDone = createAction<any>(PRINT + MEDICAL + EDIT + FETCH + DONE);
export const printMedicalEditFail = createAction<undefined>(PRINT + MEDICAL + EDIT + FETCH + FAIL);
export const printMedicalEditReset = createAction<undefined>(PRINT + MEDICAL + EDIT + FETCH + RESET);

export const getPrintRemark = createAction<any>(GET + PRINT + REMARK + FETCH);
export const getPrintRemarkDone = createAction<any>(GET + PRINT + REMARK + FETCH + DONE);
export const getPrintRemarkFail = createAction<undefined>(GET + PRINT + REMARK + FETCH + FAIL);

export const setPrintRemark = createAction<any>(SET + PRINT + REMARK + FETCH);
export const setPrintRemarkDone = createAction<any>(SET + PRINT + REMARK + FETCH + DONE);
export const setPrintRemarkFail = createAction<undefined>(SET + PRINT + REMARK + FETCH + FAIL);

export const editPrintRemark = createAction<any>(EDIT + PRINT + REMARK + FETCH);
export const editPrintRemarkDone = createAction<any>(EDIT + PRINT + REMARK + FETCH + DONE);
export const editPrintRemarkFail = createAction<undefined>(EDIT + PRINT + REMARK + FETCH + FAIL);

export const deletePrintRemark = createAction<undefined>(DELETE + PRINT + REMARK + FETCH);
export const deletePrintRemarkDone = createAction<any>(DELETE + PRINT + REMARK + FETCH + DONE);
export const deletePrintRemarkFail = createAction<undefined>(DELETE + PRINT + REMARK + FETCH + FAIL);
export const deletePrintRemarkReset = createAction<undefined>(DELETE + PRINT + REMARK + FETCH + RESET);

export const deleteMedicalResult = createAction<any>(DELETE + MEDICAL + RESULT + FETCH);
export const deleteMedicalResultDone = createAction<any>(DELETE + MEDICAL + RESULT + FETCH + DONE);
export const deleteMedicalResultFail = createAction<undefined>(DELETE + MEDICAL + RESULT + FETCH + FAIL);
export const deleteMedicalResultReset = createAction<undefined>(DELETE + MEDICAL + RESULT + FETCH + RESET);

export const getPrintTotalUvr = createAction<undefined>(GET + PRINT + TOTAL_UVR + FETCH);
export const getPrintTotalUvrDone = createAction<any>(GET + PRINT + TOTAL_UVR + FETCH + DONE);
export const getPrintTotalUvrFail = createAction<undefined>(GET + PRINT + TOTAL_UVR + FETCH + FAIL);

export const getDisciplinesPrintTotalUvr = createAction<undefined>(GET + DISCIPLINES + PRINT + TOTAL_UVR + FETCH);
export const getDisciplinesPrintTotalUvrDone = createAction<any>(GET + DISCIPLINES + PRINT + TOTAL_UVR + FETCH + DONE);
export const getDisciplinesPrintTotalUvrFail = createAction<undefined>(GET + DISCIPLINES + PRINT + TOTAL_UVR + FETCH + FAIL);

export const printJournalParams = createAction<any>(PRINT + JOURNAL + PARAMS + FETCH);
export const printJournalParamsDone = createAction<any>(PRINT + JOURNAL + PARAMS + FETCH + DONE);
export const printJournalParamsFail = createAction<undefined>(PRINT + JOURNAL + PARAMS + FETCH + FAIL);

export const printJournalSubjectList = createAction<any>(PRINT + JOURNAL + SUBJECTS + LIST + FETCH);
export const printJournalSubjectListDone = createAction<any>(PRINT + JOURNAL + SUBJECTS + LIST + FETCH + DONE);
export const printJournalSubjectListFail = createAction<undefined>(PRINT + JOURNAL + SUBJECTS + LIST + FETCH + FAIL);

export const printJournal = createAction<any>(PRINT + JOURNAL + FETCH);
export const printJournalDone = createAction<any>(PRINT + JOURNAL + FETCH + DONE);
export const printJournalFail = createAction<undefined>(PRINT + JOURNAL + FETCH + FAIL);

export const getFilteredGroups = createAction<any>(GET + FILTER + GROUPS + FETCH);
export const getFilteredGroupsDone = createAction<any>(GET + FILTER + GROUPS + FETCH + DONE);
export const getFilteredGroupsFail = createAction<undefined>(GET + FILTER + GROUPS + FETCH + FAIL);


export const getStudentByGroupID = createAction<any>(GET + STUDENT + BY + FETCH);
export const getStudentByGroupIDDone = createAction<any>(GET + STUDENT + BY + FETCH + DONE);
export const getStudentByGroupIDFail = createAction<undefined>(GET + STUDENT + BY + FETCH + FAIL);

export const getFilteredAppear = createAction<any>(GET + FILTER + APPEALS + FETCH);
export const getFilteredAppearDone = createAction<any>(GET + FILTER + APPEALS + FETCH + DONE);
export const getFilteredAppearFail = createAction<undefined>(GET + FILTER + APPEALS + FETCH + FAIL);

export const getAppearByID = createAction<any>(GET + APPEALS + ONE + FETCH);
export const getAppearByIDDone = createAction<any>(GET + APPEALS + ONE + FETCH + DONE);
export const getAppearByIDFail = createAction<undefined>(GET + APPEALS + ONE + FETCH + FAIL);

export const postAppear = createAction<any>(POST + APPEALS);
export const postAppearDone = createAction<any>(POST + APPEALS + DONE);
export const postAppearFail = createAction<undefined>(POST + APPEALS + FAIL);
export const postAppearReset = createAction<undefined>(POST + APPEALS + RESET);

export const putAppear = createAction<any>(EDIT + APPEALS);
export const putAppearDone = createAction<any>(EDIT + APPEALS + DONE);
export const putAppearFail = createAction<undefined>(EDIT + APPEALS + FAIL);
export const putAppearReset = createAction<undefined>(EDIT + APPEALS + RESET);

export const deleteAppear = createAction<any>(DELETE + APPEALS);
export const deleteAppearDone = createAction<any>(DELETE + APPEALS + DONE);
export const deleteAppearFail = createAction<undefined>(DELETE + APPEALS + FAIL);
export const deleteAppearReset = createAction<undefined>(DELETE + APPEALS + RESET);

export const getTeachersList = createAction<any>(GET + TEACHERS + FETCH);
export const getTeachersListDone = createAction<any>(GET + TEACHERS + FETCH + DONE);
export const getTeachersListFail = createAction<undefined>(GET + TEACHERS + FETCH + FAIL);